import { Component, Input, OnInit } from '@angular/core';
import { GetReceivedPortalMessagesByUserCriteriaFormBuilder } from '../../models/GetReceivedPortalMessagesByUserCriteria';
import { GRID_CONFIG } from 'src/app/shared/services/grid-center.token';
import { GridCenterService } from 'src/app/shared/services/grid-center.service';
import { BaseGridComponent } from 'src/app/shared/components/base-grid/base-grid.component';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable, first, switchMap, map, tap } from 'rxjs';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { GetSentPortalMessagesByUserCriteria } from '../../models/GetSentPortalMessagesByUserCriteria';
import { PortalMessageService } from '../../service/portal-message.service';
import { PortalMessageReceivedItem } from '../../models/PortalMessageReceivedItem';

@Component({
  selector: 'app-user-portal-received-messages-list',
  templateUrl: './user-portal-received-messages-list.component.html',
  styleUrls: ['./user-portal-received-messages-list.component.scss'],
  providers: [
    {
      provide: GRID_CONFIG,
      useValue: {
        gridName: "myReceivedMessagesGridCenter",
        initialData: {
          ...GetReceivedPortalMessagesByUserCriteriaFormBuilder.initGetReceivedPortalMessagesByUserCriteria()
        },
      },
    },
    GridCenterService,
  ],
})
export class UserPortalReceivedMessagesListComponent  extends BaseGridComponent implements OnInit {

  constructor(
    private router: Router,
    private uiNotification: UiNotificationService,
    private fb: UntypedFormBuilder,
    private messageService: PortalMessageService,
    protected gridCenterService: GridCenterService) {
    super(gridCenterService, "id");
  }

  userMessagesCount: number
  isLoading: boolean;
  searchForm: UntypedFormGroup;
  loading: boolean;
  public view: Observable<GridDataResult>;
  @Input() messageListContext = 'claims-center';

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.gridCenterService.searchCriteria$
      .pipe(first())
      .subscribe((criteria) => {
        this.searchForm = GetReceivedPortalMessagesByUserCriteriaFormBuilder.getForm(
          this.fb,
          criteria
        );
      });

    this.searchClick();
  }


  searchClick() {
    this.loading = true;
    this.setFilters<GetSentPortalMessagesByUserCriteria>(this.searchForm.value);

    this.view = this.gridCenterService.searchCriteria$.pipe(
      first(),
      switchMap((value) => this.messageService.getReceivedPortalMessagesByUser(value)),
      map(
        (result) =>
          <GridDataResult>{
            data: result,
            total: result?.length > 0 ? result[0].totalCount : 0,
          }
      ),
      tap(() => (this.loading = false))
    );
  }

  doService(r: PortalMessageReceivedItem) {
    this.setIdentifier(r.id);

    if (this.messageListContext === 'workshops-center') {
      this.router.navigate([
        "/workshopCenter/view/" + r.claimIdentifier + "/communication/" + r.threadId
      ]);
      return;
    }

    this.router.navigate([
      "/claimsCenter/view/" + r.claimIdentifier + "/handling/threadMessages/" + r.threadId
    ]);
  }

}

